module.exports = __webpack_public_path__ + "static/media/Stickies.3cea337c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Stickies.png
// module id = 20
// module chunks = 0